<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add VIP Privilege
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-format-title"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-file-input
                v-model="iconFile"
                outlined
                label="Icon Image"
                prepend-inner-icon="mdi-image"
                @change="handleIconUpload"
                :clearable="true"
                show-size
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="4"
              ></v-textarea>
            </v-col>
            <v-col sm="12" v-if="previewIcon">
              <v-card outlined>
                <v-card-title class="subtitle-2">Icon Preview</v-card-title>
                <v-card-text class="text-center">
                  <v-avatar size="80">
                    <img :src="previewIcon" alt="Icon preview" />
                  </v-avatar>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !isFormValid"
            @click="save"
          >
            Save VIP Privilege
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "VipPrivilegeCreatePage",
  data() {
    return {
      form: {
        company_id: 1,
        title: "",
        icon_path: "",
        description: "",
        is_active: 1,
      },
      iconFile: null,
      previewIcon: null,
      isLoading: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    isFormValid() {
      return this.form.title && this.form.title.trim() !== "";
    },
  },
  methods: {
    handleIconUpload(file) {
      if (file) {
        // Preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewIcon = e.target.result;
        };
        reader.readAsDataURL(file);

        // Save file reference for later upload
        this.iconFile = file;
      } else {
        this.previewIcon = null;
        this.iconFile = null;
        this.form.icon_path = "";
      }
    },

    async uploadIcon(privilegeId) {
      if (!this.iconFile) return;

      const formData = new FormData();
      formData.append("id", privilegeId);
      formData.append("icon_path", this.iconFile);

      try {
        const response = await axios.post(
          "upload_vipprivilege_image",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.form.icon_path = response.data.path; // backend returns saved path
      } catch (error) {
        console.error("Error uploading icon:", error);
        this.$toast.error("Failed to upload icon");
      }
    },

    async save() {
      if (!this.isFormValid) {
        this.$toast.error("Please fill in all required fields");
        return;
      }

      try {
        this.isLoading = true;

        // First create privilege record
        const response = await axios.post("/vip_privileges", this.form);
        const newPrivilege = response.data.data;

        // Then upload icon if selected
        if (this.iconFile) {
          await this.uploadIcon(newPrivilege.id);
        }

        // Save user timestamp
        await this.saveUserTimestamp(null, this.form);

        this.isLoading = false;
        this.$router.push("/vip-privileges");
      } catch (e) {
        console.log(e);
        this.$toast.error("Failed to create VIP Privilege");
        this.isLoading = false;
      }
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        let form = {
          from_path: `/vip-privileges/create`,
          from_name: "VipPrivilegeCreatePage",
          user_id: this.user.id,
          old_json: oldData ? JSON.stringify(oldData) : null,
          new_json: JSON.stringify(newData),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
